import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelAccountsRoute from 'lumen/routes/hotel/accounts';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelAccountsController extends Controller {
  declare model: ModelFrom<HotelAccountsRoute>;

  queryParams = [
    'asofDate',
    'channels',
    'companies',
    'data_replatforming',
    'dateRageEnd',
    'dateRageStart',
    'leadTime',
    'leadTimeComp',
    'lengthOfStay',
    'lengthOfStayComp',
    'marketCategories',
    'marketSegments',
    'ratePlanDescriptions',
    'ratePlans',
  ];

  @service declare currency: Services['currency'];
  @service declare currencyConversion: Services['currency-conversion'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get iframeQPs(): Record<string, unknown> {
    const iframeQPs: Record<string, unknown> = {
      iframe: 1,
      origin: window.location.origin,
    };

    if (this.currency.selectedCurrency) {
      iframeQPs['currency'] = this.currency.selectedCurrency;
    }

    if (this.currencyConversion.selectedProfileId) {
      iframeQPs['currencyVariant'] = this.currencyConversion.selectedProfileId;
    }

    if (this.hotelAndMarketService.hotel) {
      iframeQPs['subscriptionId'] = this.hotelAndMarketService.hotel.id;
    }

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const value = this[queryParam]!;

      if (value) {
        iframeQPs[queryParam] = value;
      }
    });

    return iframeQPs;
  }

  get urlForEmbeddedApp(): string {
    const { model } = this;

    // @ts-expect-error: Incorrect type
    return `/dashboards/account-analysis/${model.spiderId}`;
  }

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    this.queryParams.forEach((queryParam) => {
      // @ts-expect-error: Incorrect type
      this[queryParam] = null;
    });
  }
}
